import React from 'react'
import { connect } from 'react-redux'
import { Row, Table, Tooltip } from 'antd'
import ReactTimeAgo from 'react-time-ago/commonjs/ReactTimeAgo'
import BigNumber from 'bignumber.js'
import NumberFormat from 'react-number-format'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { loadRecentTrans } from '@/actions/home'
import { mapTransactionType } from '@/utils/utils'
import PageHeader from '@/v2/components/PageHeader'
import Label from '@/v2/components/Label'
import TruncateMiddle from 'react-truncate-string'

const Wrapper = styled.div`
  margin-top: 25px;
`
const Token = styled.span`
  color: ${({ theme }) => theme.colors_v2.primary_yellow};
`

const StatusTag = styled.span`
  background: ${({ status }) => (status ? '#28CE7E' : '#17134a')};
  padding: 4px 6px;
  border-radius: 90px;
  font-weight: 400;
  font-size: 10px;
  line-height: 16px;
`

class RecentTransactions extends React.Component {
  componentDidMount() {
    this.props.loadRecentTrans()
  }

  handleAmount = (transaction) => {
    const type = transaction.contract.type
    let {
      amount = 0,
      precision,
      decimal,
      frozen_balance,
      name,
      symbol,
      unfreeze_amount,
      withdraw_amount,
    } = transaction.contract.parameter.raw ? transaction.contract.parameter.raw : {}

    if (decimal === -1) {
      decimal = 6
    }
    if (type === 'FreezeBalanceContract') {
      amount = frozen_balance || 0
    } else if (type === 'UnfreezeBalanceContract') {
      amount = unfreeze_amount || 0
    } else if (type === 'WithdrawBalanceContract') {
      amount = withdraw_amount || 0
    }

    switch (type) {
      case 'TransferContract':
      case 'FreezeBalanceContract':
      case 'UnfreezeBalanceContract':
      case 'WithdrawBalanceContract':
        return (
          <>
            <NumberFormat
              displayType="text"
              thousandSeparator
              value={amount / Math.pow(10, decimal)}
            />
            <Label> {name === 'WEL' ? 'WELUPS' : name}</Label>
          </>
        )
      case 'TransferAssetContract':
      case 'TriggerSmartContract':
        return (
          <>
            <NumberFormat
              displayType="text"
              thousandSeparator
              value={amount / Math.pow(10, precision ? precision : decimal)}
            />
            <Label> {symbol}</Label>
          </>
        )
      default:
        return '-'
    }
  }

  columns = [
    {
      render: ({ hash }) => (
        <>
          <Label>Transaction: </Label>
          <Link to={`/transaction/${hash}`} style={{ fontWeight: 'bold' }} target="_blank">
            {hash.substring(0, 10) + '...'}
          </Link>
        </>
      ),
      width: '22%',
    },
    {
      render: ({ contract }) => (
        <>
          <Label>Type: </Label>
          <b>{mapTransactionType(contract.type)}</b>
        </>
      ),
      width: '22%',
    },

    {
      width: '12%',
      render: (record) => {
        const type = record.contract.type
        const name = record.contract.parameter.raw ? record.contract.parameter.raw.name : '–'
        let symbol = record.contract.parameter.raw ? record.contract.parameter.raw.symbol : '–'
        const result = name + (symbol == '–' || symbol == '' ? '' : ' (' + symbol + ')')
        if (name === 'WEL') {
          symbol = 'WELUPS'
        }
        return (
          <Token>
            <Tooltip placement="top" title={result}>
              <TruncateMiddle text={symbol || '–'} />
            </Tooltip>
          </Token>
        )
      },
    },
    {
      width: '17%',
      render: (record) => {
        return this.handleAmount(record)
      },
    },
    {
      dataIndex: 'confirmed',
      width: '12%',
      key: 'confirmed',
      render: (confirmed) => {
        return <StatusTag status={confirmed}>{confirmed ? 'Confirmed' : 'UnConfirmed'}</StatusTag>
      },
    },
    {
      render: ({ timestamp }) => (
        <Label>
          {timestamp ? <ReactTimeAgo date={new Date(timestamp)} locale="en-US" /> : 'unknown'}
        </Label>
      ),
      width: '15%',
    },
  ]

  render() {
    const trans = this.props.trans ?? []
    trans.sort(function (a, b) {
      return b.timestamp - a.timestamp
    })

    return (
      <Wrapper>
        <Row align="middle" justify="space-between">
          <PageHeader>Recent Transactions</PageHeader>
          <Link to="/transactions">more &gt;</Link>
        </Row>
        <Table
          rowKey={(record) => record.timestamp}
          columns={this.columns}
          dataSource={trans.slice(0, 6)}
          showHeader={false}
          pagination={false}
          loading={trans.length === 0 ? true : false}
          scroll={{ x: 768 }}
        />
      </Wrapper>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    trans: state.homeTrans.trans,
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    loadRecentTrans: () => {
      dispatch(loadRecentTrans())
    },
  }
}
export default connect(mapStateToProps, mapDispatchToProps, null, {
  forwardRef: true,
})(RecentTransactions)
